import type { IntentosInfo } from "@/shared/utils/intentos";

type Props = {
  info: Pick<IntentosInfo, "usados" | "total">;
  className?: string;
  icon?: React.ReactNode;
};

/** Muestra los intentos del aprendiz con el formato "Intentos: x/y". */
export function IntentosBadge({ info, className, icon }: Props) {
  return (
    <span className={className}>
      {icon}
      Intentos: {info.usados}/{info.total}
    </span>
  );
}
